module.exports = __webpack_public_path__ + "img/snake-alco-t.4f56080e.gif";